import { StyleDeclarationValue, css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ActivityViewModel } from '../../../viewModels/memes';
import { Button } from '../../../../web/components-v2/Button';
import { styleSheet } from './styles';

interface IProps {
	activity: ActivityViewModel;
	className?: string;
	onClick?(): void;
	selected: boolean;
	styles?: StyleDeclarationValue[];
}

export const ActivityListHeader: React.FC = () => (
	<div className={css(styleSheet.header)}>
		<div className={css(styleSheet.headerLabel)}>Activity</div>
		<div className={css(styleSheet.headerNumber)}>Points</div>
		<div className={css(styleSheet.headerNumber)}>Memes</div>
	</div>
);

export const Activity: React.FC<IProps> = observer(props => {
	const { className, activity, onClick, selected, styles = [] } = props;

	return (
		<Button
			variant='ghost'
			aria-pressed={selected}
			selectorClassName={`activity ${className || ''}`}
			onClick={onClick}
			styles={[styleSheet.row, selected && styleSheet.rowSelected, ...styles]}
		>
			<span className={css(styleSheet.label, selected && styleSheet.labelSelected)}>{activity.label}</span>
			<span className={css(styleSheet.number)}>{activity.points}</span>
			<span className={css(styleSheet.number, styleSheet.memeCount)}>{activity.memes}</span>
		</Button>
	);
});
